import React from 'react'
import avatarImg from '../assets/avatar.png'
import { AiOutlineHeart, AiOutlineComment, AiOutlineShareAlt } from 'react-icons/ai'

// Use this component to easily format your important texts!
const Highlight = ({ children }) => (
  <span className="underline text-black">{children}</span>
);

// ==========================================
// EDIT YOUR TEXTS AND DATA HERE
// ==========================================
const ABOUT_ME_DATA = {
  heading: "Who's this guy?",

  // You can wrap important text in <Highlight>text</Highlight> to make it black and underlined
  paragraph1: (
    <>
      I am a creative and experienced game designer with a <Highlight>BSc in Game Design and Development</Highlight>, seeking a challenging role where I can apply my following skills in creating immersive, innovative and original games.
    </>
  ),

  paragraph2: (
    <>
      Apart from being a detail-oriented game designer with more than <Highlight>5 years</Highlight> of hands-on experience I have also worked across different genres of games including <Highlight>FPS, Open world, casual, hyper-casual, AR, VR, slots and board games</Highlight>, I have released <Highlight>19+ titles</Highlight> that have been enjoyed by <Highlight>Lakhs of players</Highlight> both on <Highlight>PC and Mobiles platforms</Highlight>. I am passionate about making an impact in the gaming industry and my previous experience includes leading a team of talented people along with my deep knowledge of gaming trends, storytelling ability, creativity, critical thinking, analytical thinking, and logical thinking both as a <Highlight>Product Designer and Game Designer</Highlight>.
    </>
  ),

  paragraph3: (
    <>
      I am always eager to learn new skills and technologies. I am looking forward to applying my talents, collaborate with and maybe even lead a dynamic team of game developers.
    </>
  )
};
// ==========================================

const AboutMe = () => {
  return (
    <div className="p-4 mt-8">
      <div className="max-w-4xl lg:max-w-[90rem] mx-auto bg-fgGreen rounded-2xl border-4 border-black p-6" style={{ boxShadow: '5px -5px 0px 0px black' }} id="about-me-section">
        <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-6">
          <div className="flex-1  ">
            <div className=' inline-block'>
              <div className="bg-fgPurple rounded-2xl shadow-md border-4 border-black py-4 px-12" style={{ boxShadow: '-3px 3px 0px 0px black' }}>
                <h2 className="text-white text-lg md:text-3xl text-center font-semibold">{ABOUT_ME_DATA.heading}</h2>
              </div>
            </div>

            <p className="text-white text-base md:text-2xl font-bold my-8 font-clash-display-semibold">
              {ABOUT_ME_DATA.paragraph1}
            </p>
            <p className="text-white text-base md:text-2xl font-bold my-8 font-clash-display-semibold">
              {ABOUT_ME_DATA.paragraph2}
            </p>
            <p className="text-white text-base md:text-2xl font-bold my-8 font-clash-display-semibold">
              {ABOUT_ME_DATA.paragraph3}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutMe
